import React from "react";
import { getPercentage } from "../resources/helper/helper";
import { useNavigate } from "react-router-dom";

const ProductListCard = ({ item }) => {
  const navigate = useNavigate();

  const handleDetailsNavigation = () => {
    navigate("/productDetails", { state: item });
  };
  return (
    <article
      className="row align-items-center hover-up"
      onClick={handleDetailsNavigation}
    >
      <figure className="col-md-4 mb-0">
        <a>
          <img src={item?.featured_media} alt="" />
        </a>
      </figure>
      <div className="col-md-8 mb-0">
        <h6>
          <a>{item?.name}</a>
        </h6>
        <div className="product-rate-cover">
          <div className="product-rate d-inline-block">
            <div
              className="product-rating"
              style={{
                width: `${getPercentage(item?.ratings?.averageRating)}%`,
              }}
            />
          </div>
          <span className="font-small ml-5 text-muted">
            {" "}
            {`(${
              item?.ratings?.averageRating ? item?.ratings?.averageRating : 0
            })`}
          </span>
        </div>
        <div className="product-price">
          <span>Rs.{item?.discount_price}</span>
          <span className="old-price">Rs.{item?.price}</span>
        </div>
      </div>
    </article>
  );
};

export default ProductListCard;
